<template>
    <div>
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
        >
            <el-row :gutter="40">
                <el-col :xs="24" :sm="16">
                    <el-form-item prop="roleName" label="角色名称">
                        <el-input
                            placeholder="请输入角色名称"
                            v-model="formData.roleName"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="16">
                    <el-form-item prop="remarks" label="角色描述">
                        <el-input
                            type="textarea"
                            autosize
                            placeholder="请输入角色描述"
                            v-model="formData.remarks"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item prop="priIdList" label="角色权限">
                <el-tree
                    v-if="reFresh"
                    :data="permissions"
                    show-checkbox
                    node-key="id"
                    ref="permissionTree"
                    :default-checked-keys="defaultCheckedKeys"
                    :props="defaultProps"
                    v-loading="treeLoading"
                >
                </el-tree>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">返回取消</el-button>
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >确认提交</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
// import { getPrivileges } from "@/assets/js/commonApi";
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    data() {
        return {
            formData: {
                roleName: "",
                remarks: "",
                priIdList: [],
            },
            rules: {
                roleName: [{ required: true, message: "请输入角色名称" }],
            },
            permissions: [],
            defaultCheckedKeys: [],
            defaultProps: {
                children: "children",
                label: "priName",
            },
            treeLoading: false,
            btnLoading: false,
            redirect: this.$route.query.redirect || "/system/fb/role/list",
            reFresh:false,
        };
    },
    async created() {
        await this.getPermissions();
        if (this.id) {
            this.getRoleData();
        }else{
            this.reFresh = true;
        }
    },
    methods: {
        //权限列表
        getPermissions() {
            this.treeLoading = true;
            this.$request({
                url: "/suduPrivilege/list",
                method: "POST",
                data: {parentId: ""}
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        const _result = result.filter(
                            (item) => item.status == 1
                        );
                        this.permissions = this.treePermissions(_result);
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.treeLoading = false;
                });
        },
        // 获取角色详情
        getRoleData() {
            this.$request({
                url: "/suduRole/detail",
                method: "POST",
                data: { id: this.id },
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    const adminPrivilegeList =  result.suduPrivilegeList.filter( v => v.checked == 1 );
                    adminPrivilegeList.forEach( item => {
                        const _p = result.suduPrivilegeList.find(v => item.id == v.parentId);
                        if( !_p ){
                            this.defaultCheckedKeys.push( item.id );
                        }
                    });
                    this.formData = {
                        id: result.id,
                        remarks: result.description,
                        roleName: result.roleName,
                        sort: result.sort,
                        priIdList: this.defaultCheckedKeys
                    }
                    this.reFresh = true;
                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            });
        },
        //权限树
        treePermissions(data) {
            // 递归方法
            function getNode(id) {
                const node = [];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].parentId === id) {
                        data[i].children = getNode(data[i].id);
                        node.push(data[i]);
                    }
                }
                if (node.length === 0) return [];
                return node;
            }
            return getNode(0);
        },
        //获取选中树
        setPriIdList() {
            const halfKeys = this.$refs.permissionTree.getHalfCheckedKeys() || [];
            const keys = this.$refs.permissionTree.getCheckedKeys() || [];
            this.formData.priIdList = halfKeys.concat(keys);
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                this.setPriIdList();
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: !this.id ? "/suduRole/add" : "/suduRole/edit",
                        method: "POST",
                        data: this.formData,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            this.$router.push({
                path: this.redirect,
            });
        },
    },
};
</script>